import React from 'react';
import { toast, ToastContainer } from 'react-toastify';
import cssnames from 'classnames';
import { IconCircleCheck, IconCircleClose } from '../components/icons';
import Styles from '../components/toast/toast-styles.scss';
function useCustomToast({ containerId = 'main-dashboard-container', toastClassName } = {}) {
    // const containerRef = useRef<ToastContainer>(null);
    const showToast = (message, position = 'top-center') => {
        toast(message, {
            containerId,
            position
        });
    };
    const showCustomErrorIcon = (title, subtitle, icon) => {
        toast.error(React.createElement("div", { "data-testid": "error-toast" },
            React.createElement("div", { className: Styles.titleError }, title),
            React.createElement("div", { className: Styles.subtitleError }, subtitle)), {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'colored',
            icon,
            containerId
        });
    };
    const showCustomError = (title, subtitle) => {
        toast.error(React.createElement("div", { "data-testid": "error-toast" },
            React.createElement("div", { className: Styles.titleError }, title),
            React.createElement("div", { className: Styles.subtitleError }, subtitle)), {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'colored',
            icon: React.createElement(IconCircleClose, null),
            containerId
        });
    };
    const showCustomSuccess = (title, subtitle) => {
        toast.success(React.createElement("div", { "data-testid": "success-toast" },
            React.createElement("div", { className: Styles.titleSuccess }, title),
            React.createElement("div", { className: Styles.subtitleSuccess }, subtitle)), {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'colored',
            icon: React.createElement(IconCircleCheck, { color: "white" }),
            containerId
        });
    };
    const showCustomWarning = (title, subtitle) => {
        toast.warn(React.createElement("div", null,
            React.createElement("div", { className: Styles.titleSuccess }, title),
            React.createElement("div", { className: Styles.subtitleSuccess }, subtitle)), {
            position: 'top-center',
            autoClose: 10000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'colored',
            containerId
        });
    };
    const toastContainer = (React.createElement(ToastContainer // ref={containerRef}
    , { position: "top-center", autoClose: 5000, hideProgressBar: true, newestOnTop: false, closeOnClick: true, rtl: false, pauseOnFocusLoss: true, draggable: true, pauseOnHover: true, theme: "colored", toastClassName: cssnames([Styles.toastClassName, toastClassName]), enableMultiContainer: true, containerId: containerId, className: Styles.rootToast }));
    return { showToast, showCustomError, toastContainer, showCustomErrorIcon, showCustomSuccess, showCustomWarning };
}
export default useCustomToast;
